import { render, staticRenderFns } from "./addQuestionBank.vue?vue&type=template&id=b33ffa14&scoped=true&"
import script from "./addQuestionBank.vue?vue&type=script&lang=js&"
export * from "./addQuestionBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33ffa14",
  null
  
)

export default component.exports